import { Sparkles } from "lucide-react";

export default function PremiumBadge({ variant = "icon", className = "" }) {
  if (variant === "full") {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[color:var(--stars-gold)] text-[11px] font-bold text-[color:var(--ink)] ${className}`}>
        <Sparkles className="w-3 h-3" /> Premium
      </span>
    );
  }
  if (variant === "pill") {
    return (
      <span className={`px-1.5 py-0.5 rounded-full bg-[color:var(--stars-gold)] text-[10px] font-bold text-[color:var(--ink)] ${className}`}>
        P
      </span>
    );
  }
  return <Sparkles className={`w-3.5 h-3.5 text-[color:var(--stars-gold)] flex-shrink-0 ${className}`} />;
}
